<template>
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.6975 16.4201C17.8945 15.9811 17.3335 15.2131 17.1555 14.2971C16.8745 13.0641 17.3625 11.7911 18.4175 11.0421C18.5225 10.9591 18.7705 10.7661 18.7985 10.4441C18.8265 10.1281 18.6235 9.90012 18.5685 9.83912C17.5775 8.64812 16.0135 8.07312 14.4905 8.34712C13.9405 8.44212 13.3955 8.61312 12.8675 8.85712C12.3945 9.08112 11.8355 9.07112 11.3755 8.83512C9.34949 7.77612 6.84049 8.47712 5.66049 10.4341C4.99449 11.4661 4.67349 12.7151 4.75449 13.9201C4.75849 15.1071 4.98249 16.2741 5.41549 17.3791C5.90949 18.7461 6.69249 20.0171 7.64349 21.0141C8.14249 21.6631 8.90149 22.0111 9.66649 22.0101C10.1035 22.0101 10.5425 21.8971 10.9355 21.6621C11.7645 21.2271 12.7665 21.2091 13.5645 21.5821C14.8045 22.3571 16.4265 22.0231 17.2195 20.8691C18.0635 19.9061 18.7125 18.8171 19.1515 17.6201C19.3675 17.0111 19.2725 16.7541 18.6975 16.4201Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0358 7.98834H12.0428C13.2668 7.97134 14.3338 7.48234 15.0478 6.60834C15.7558 5.74034 16.0208 4.60634 15.7948 3.41534C15.7478 3.16734 15.5178 2.98934 15.2718 3.00934C14.1328 3.08134 13.1188 3.58334 12.4178 4.42534C11.7058 5.27734 11.3908 6.38634 11.5288 7.54834C11.5588 7.79934 11.7828 7.98834 12.0358 7.98834Z"
    />
  </svg>
</template>

<script>
export default {
  name: "IconAppleStore",
};
</script>
